<template>
	<div style="padding: 50px">
		<div id="circle" v-if="isLoading">
			<div class="loader"></div>
		</div>

		<div v-else>
			<h1 style="font-size: 32px; margin-bottom: 20px;">{{ StringLanguage.importCatalog }}</h1>

			<div class="row">
				<div class="col-md-6">
					<div class="customer-box">
						<div class="box">
							<h3 style="font-size: 14px">Digite a url pública do estabelecimento que deseja importar</h3>

							<input type="text" class="input" v-model="url" ref="sendUrl">
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<div class="customer-box">
						<div class="box">
							<h3 style="font-size: 14px">Digite a url da loja do Easy</h3>

							<input type="text" class="input" v-model="target" ref="targetUrl">
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<div class="customer-box">
						<div class="box">
							<input type="checkbox" id="catalog" v-model="options.catalog" >
							<label for="catalog">Cardápio</label>
							<br>

							<input type="checkbox" id="info" v-model="options.info" >
							<label for="info">Informações da loja</label>
							<br>

							<input type="checkbox" id="location" v-model="options.location" >
							<label for="location">Localização</label>
							<br>

							<input type="checkbox" id="openingHours" v-model="options.openingHours" >
							<label for="openingHours">Horários de atendimento</label>
							<br>

							<input type="checkbox" id="images" v-model="options.images" >
							<label for="images">Imagens</label>
							<br>

							<input type="checkbox" id="paymentMethods" v-model="options.paymentMethods" >
							<label for="paymentMethods">Formas de pagamento</label>
							<br>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<div class="customer-box">
						<div class="box">
							<button class="btn btn-one pull-right" @click="sendToCrawler">
								<span>Importar</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import StoreAPI from '@/api/store';
import CatalogAPI from '@/api/catalog';
import Utils from "@/utils";

export default {
	data() {
		return {
			url: 'https://www.ifood.com.br/delivery/',
			target: 'http://easydelivery.com.br/implantacao1',
			catalog: [],
			userCatalog: [],
			username: '',
			password: '',
			isLogged: false,
			hasCronJobFinished: false,
			isLoading: false,
			jobId: 151,
			options: {
				catalog: false,
				info: false,
				location: false,
				images: false,
				openingHours: false,
				paymentMethods: false
			},
			Utils
		}
	},

	methods: {
		async sendToCrawler() {
			this.isLoading = true;
			this.hasCronJobFinished = false;
			const { catalog, info, location, openingHours, images, paymentMethods } = this.options;

			if (!this.url || !this.target || ![catalog, info, location, openingHours, images, paymentMethods].some(option => option)) {
				alert("Confira os dados antes de enviar");
				this.isLoading = false;
				return false;
			}

			const [environment] = this.target.split('/').slice(-1);
			const { is_environment } = (await StoreAPI.isEnvironment(environment)).getData();

			if (!is_environment) {
				this.isLoading = false;
				alert("Ambiente não encontrado. Verifique novamente");

				return;
			}

			const response = await StoreAPI.catalogImporter({ url: this.url, target: this.target, options: this.options });

			if (response.getErrors([]).length > 0) {
				this.isLoading = false;
				alert("Erro ao fazer importação");

				return;
			}

			const { id } = response.getData();
			this.jobId = id;

			this.verifyWhetherCronJobHasFinished();
		},

		async verifyWhetherCronJobHasFinished() {
			if (!this.hasCronJobFinished) {
				const response = await StoreAPI.verifyWhetherCronJobHasFinished(this.jobId);
				const { job: { status }} = response.getData();

				if (status == 'PROCESSED') {
					this.hasCronJobFinished = true;

					const [environment] = this.target.split('/').slice(-1);
					await CatalogAPI.catalogUpdate(environment);

					this.isLoading = false;
					alert("Importação Finalizada");
					return;
				} else if (status == 'ERROR') {
					this.hasCronJobFinished = true;
					this.isLoading = false;
					alert("Aconteceu um erro na importação");

					return;
				}

				setTimeout(this.verifyWhetherCronJobHasFinished, 3000);
			}
		}
	},

	components: {}
}
</script>

<style scoped>
.pull-right {
	float: right;
}

button + button {
	margin-left: 10px;
}

.category-title{
	padding: 15px 25px;
	border-radius: 5px;
	color: white;
	font-size: 1em;
	font-weight: 900;
	text-transform: uppercase;
	opacity: .8;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 1em;
}

.box {
    background-image: radial-gradient(circle, #ffffff, #fefefe, #fefefe, #fdfdfd, #fcfcfc);
    border-radius: 5px;
    padding: 20px;
    box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2);
    overflow: hidden;
    margin-bottom: 30px;
}

.box-category, .box-product{
	opacity: 1;
	transition: .5s linear;
}

.box-product{
    background: #fff;
    border: 1px solid #E3E3E3;
    border-radius: 5px;
    padding: 17px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.3em;
    color: #999;
}

.box-name {
	padding: 30px 10px;
}

.box-name h2 {
	font-size: 16px;
	font-weight: 700;
    color: #999;
}

input + label {
	font-size: 16px;
}

.btn-one {
  background-color: var(--default);
  color: #fff;
  border: none;
  padding: 10px 15px;
  font-size: 12px;
}

.btn {
    text-align: center;
    border-radius: 5px;
    outline: none;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.input {
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
    font-size: 14px;
    padding: 12px 18px;
    color: #777;
	margin: 10px 0;
}

.pull-center {
	margin: 0 auto;
}

#circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
	width: 100px;
    height: 100px;
}

.loader {
    width: calc(100% - 0px);
	height: calc(100% - 0px);
	border: 15px solid #22a7ff;
	border-top: 15px solid #0085dd;
	border-radius: 50%;
	animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
	100% {transform: rotate(360deg);}
}
</style>